/**
 * Home-page sections, in document order.
 *
 * The header nav, the mobile drawer and the scrollspy all read from this list,
 * so adding a section is one entry here plus the section component itself.
 */
export const SECTIONS = [
  { id: "features", label: "The Game" },
  { id: "locations", label: "Maps" },
  { id: "loadout", label: "Perks" },
  { id: "media", label: "Media" },
  { id: "community", label: "Community" },
  { id: "download", label: "Download" },
] as const;

export type SectionId = (typeof SECTIONS)[number]["id"];
